var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"banner-container",class:[_vm.containerClass, _vm.isTabBarDisplayed && 'toast-with-tab-bar']},[_vm._l((_vm.banners),function(banner){return [(banner.show)?_c('banner-content',{key:banner.name,attrs:{"banner":banner},on:{"removed":_vm.bannerRemoved}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }